import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import gsap from 'gsap';
import Loader from '../components/Loader/Loader';
import Hero from '../components/Hero/Hero';
import Trust from '../components/Trust/Trust';
import About from '../components/About/About';
import Services from '../components/Services/Services';
import Process from '../components/Process/Process';
import CaseStudies from '../components/CaseStudies/CaseStudies';
import Team from '../components/Team/Team';
import Testimonials from '../components/Testimonials/Testimonials';
import Contact from '../components/Contact/Contact';
import Footer from '../components/Footer/Footer';
import Header from '../components/Header/Header';
import styles from './Home.module.scss';

const Home: React.FC = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (!loading) {
      // Force ScrollTrigger to recalculate all positions after the DOM is fully injected 
      // and any initial images/fonts might have shifted the layout.
      setTimeout(() => {
        ScrollTrigger.refresh();
      }, 100);
      
      setTimeout(() => {
        ScrollTrigger.refresh();
      }, 500);
    }
  }, [loading]);

  const handleLoaderComplete = () => {
    setLoading(false);
  };

  return (
    <>
      <Helmet>
        <title>Rash Digital Marketing | Best SEO & Digital Marketing Agency in Indore</title>
        <meta name="description" content="Rash Digital Marketing is the leading digital marketing agency in Indore. Since 2019, we specialize in result-driven SEO, Local SEO (GBP), Meta & Google Ads, and Custom Web Design." />
        <meta name="keywords" content="digital marketing agency in indore, seo company in indore, local seo services indore, google business profile optimization, social media marketing indore, website design company indore, google ads agency indore, meta ads specialist, rash digital marketing, rash digital" />
      </Helmet>

      <div className={styles.homeContainer}>
        {loading ? (
          <Loader onComplete={handleLoaderComplete} />
        ) : (
          <main className={styles.mainContent}>
            <Header />
            <Hero />
            <Trust />
            <About />
            <Services />
            <Process />
            <CaseStudies />
            <Team />
            <Testimonials />
            <Contact />
            <Footer />
          </main>
        )}
      </div>
    </>
  );
};

export default Home;
